import QuestionTips from "./components/QuestionTips";
import { uniqueId } from "@/views/zhiji/js/common/util.js";
import i18n from "@/i18n";

const color = "#bf600c";

// link，question，higlight配置
export default {
    type: "question",
    labelKey: "zhiji.answer.textWidget.linkQuestion",
    cls: "",
    tipsComponent: QuestionTips,
    editorHandler: (store, data, cb) => {
        store.dispatch("zhiji/showModal", {
            type: "QuestionSelectorTableModal",
            data: {
                title: i18n.t("zhiji.answer.textWidget.linkQuestion"),
                id: data && data.id,
                word: data.word,
                wordColor: color, // TODO 暂时写死颜色
                question: data.question || "",
                questionId: data.questionId || "",
                currentLang: data.language,
                confirm: edited => {
                    const id = data.id || `${uniqueId()}`;
                    const elem = {
                        id,
                        tag: "span",
                        innerText: data.word,
                        editable: false,
                        attrs: [{ name: "data-type", value: "question" }],
                        styles: [{ name: "color", value: color }]
                    };
                    const node = {
                        id,
                        type: "question",
                        word: data.word,
                        question: edited.questionData.question,
                        questionId: edited.questionData.questionId
                    };

                    cb({ elem, node, operate: edited.type });
                },
                cancel: () => {
                    // TODO
                }
            }
        });
    },
    toHtml(node) {
        return `<span id=${node.id} style="color: ${color}" data-type="question" contenteditable="false">${node.word}</span>`;
    },
    fromOut(word) {
        return { ...word };
    },
    toOut(node) {
        return { ...node };
    },
    getTips(node) {
        return node;
    }
};
